type MessageMap = Record<string, string>;

export const messageOrEmpty = (messages: MessageMap | undefined, key: string): string => messages?.[key] ?? '';

export const disconnectObserver = (observer?: IntersectionObserver): void => {
  observer?.disconnect();
};

export const shouldSkipLoadingItems = (variant: string, endpoint: string): boolean =>
  variant !== 'variante1' || !endpoint;
